import React, { forwardRef, type Ref } from 'react';
import { type AppSwitcherProps, IconButton } from '@atlaskit/atlassian-navigation';
import Icon from '@atlaskit/icon';
import type { CustomGlyphProps, GlyphProps } from '@atlaskit/icon/types';

const AppSwitcherNav4IconGlyph = (props: CustomGlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5 7C5 5.89543 5.89543 5 7 5H9C10.1046 5 11 5.89543 11 7V9C11 10.1046 10.1046 11 9 11H7C5.89543 11 5 10.1046 5 9V7ZM7 6.5C6.72386 6.5 6.5 6.72386 6.5 7V9C6.5 9.27614 6.72386 9.5 7 9.5H9C9.27614 9.5 9.5 9.27614 9.5 9V7C9.5 6.72386 9.27614 6.5 9 6.5H7ZM13 7C13 5.89543 13.8954 5 15 5H17C18.1046 5 19 5.89543 19 7V9C19 10.1046 18.1046 11 17 11H15C13.8954 11 13 10.1046 13 9V7ZM15 6.5C14.7239 6.5 14.5 6.72386 14.5 7V9C14.5 9.27614 14.7239 9.5 15 9.5H17C17.2761 9.5 17.5 9.27614 17.5 9V7C17.5 6.72386 17.2761 6.5 17 6.5H15ZM5 15C5 13.8954 5.89543 13 7 13H9C10.1046 13 11 13.8954 11 15V17C11 18.1046 10.1046 19 9 19H7C5.89543 19 5 18.1046 5 17V15ZM7 14.5C6.72386 14.5 6.5 14.7239 6.5 15V17C6.5 17.2761 6.72386 17.5 7 17.5H9C9.27614 17.5 9.5 17.2761 9.5 17V15C9.5 14.7239 9.27614 14.5 9 14.5H7ZM13 15C13 13.8954 13.8954 13 15 13H17C18.1046 13 19 13.8954 19 15V17C19 18.1046 18.1046 19 17 19H15C13.8954 19 13 18.1046 13 17V15ZM15 14.5C14.7239 14.5 14.5 14.7239 14.5 15V17C14.5 17.2761 14.7239 17.5 15 17.5H17C17.2761 17.5 17.5 17.2761 17.5 17V15C17.5 14.7239 17.2761 14.5 17 14.5H15Z"
			fill="currentColor"
		/>
	</svg>
);

const AppSwitcherNav4Icon = (props: GlyphProps) => (
	<Icon glyph={AppSwitcherNav4IconGlyph} {...props} />
);

const AppSwitcherNav4 = forwardRef((props: AppSwitcherProps, ref: Ref<HTMLElement>) => {
	const { tooltip, ...iconButtonProps } = props;

	return (
		<IconButton
			icon={<AppSwitcherNav4Icon label={typeof tooltip === 'string' ? tooltip : 'Switch apps'} />}
			tooltip={tooltip}
			ref={ref}
			{...iconButtonProps}
		/>
	);
});

export default AppSwitcherNav4;
